import { render, staticRenderFns } from "./SimproJobSetStatusModal.vue?vue&type=template&id=35bdad8c&"
import script from "./SimproJobSetStatusModal.vue?vue&type=script&lang=ts&"
export * from "./SimproJobSetStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports